/**
 * Socket.io live match updates — shared tuning (iOS, Android, Web).
 */

export const LIVE_MATCH_UPDATE_EVENT = 'match:update' as const;

/** Client → server: replace socket membership in match:<id> rooms (see server socketMatchIo.helper.js) */
export const SOCKET_CLIENT_SUBSCRIBE_MATCHES_EVENT = 'subscribe:matches' as const;

/**
 * Minimum spacing between React Query invalidation bursts after match:update.
 * Coalesces rapid ticks into fewer refetches (battery / API / DB).
 */
export const LIVE_MATCH_UPDATE_INVALIDATE_WINDOW_MS = 2500;

/** Debounce recomputing subscribe:matches after cache changes (must stay ≤ server SOCKET_MAX_SUBSCRIBE_MATCH_IDS) */
export const LIVE_SUBSCRIPTION_RESYNC_DEBOUNCE_MS = 400;

export const LIVE_SUBSCRIPTION_MAX_MATCH_IDS = 250;
